/* eslint-disable vue/one-component-per-file */
import { defineComponent, useSlots, renderSlot } from 'vue';
import AgNoRowsOverlay from '../AgNoRowsOverlay.vue';

/**
 * ag-grid为空时的显示组件
 */
export function getNoRowsOverlayComponent(noRowsMessage?: string) {
  const slots = useSlots();
  // 没有empty slot
  if (!slots.empty) {
    // 默认组件
    if (noRowsMessage) {
      return defineComponent({
        props: {
          params: {
            type: Object,
            required: true
          }
        },

        setup() {
          return () => <AgNoRowsOverlay message={noRowsMessage} />;
        }
      });
    }

    return undefined;
  }

  return defineComponent({
    props: {
      params: {
        type: Object,
        required: true
      }
    },

    setup() {
      return () => <div>{renderSlot(slots, 'empty')}</div>;
    }
  });
}
